import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import classes from './scss/baseModal.module.scss';
import { useWindowSize } from '../../../utils/hooks';
import { maxMobileSize } from '../../../utils/constants';
import colors from '../../../scss/colors';
import MainButton from '../buttons/MainButton';

function BaseModal(props) {
  const { t } = useTranslation();
  const {
    open = false,
    fullscreen,
    closeHandler,
    confirmHandler,
    pending = false,
    error = false,
    title,
    children,
    disableConfirmBtn = false,
    confirmBtnTxt = t('common.general.save'),
    cancelBtnTxt = t('common.general.back'),
    onlyConfirm = false,
    onlyReject = false,
    hideHeader = false,
    hideFooter = false,
    zIndex = 1600,
    disablePortal = false,
    backgroundColor = colors.WHITE,
    container = document.body,
    marginLeftRight = 4,
    minWidth,
    dialogContentStyle,
    paperStyles = {}
  } = props;

  const size = useWindowSize();

  return (
    <Dialog
      container={container}
      disablePortal={disablePortal}
      fullScreen={fullscreen}
      open={!!open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        minHeight: 500,
        maxHeight: 700,
        maxWidth: '100%',
        zIndex,
        '& .MuiDialog-paper': {
          borderRadius: '20px',
          overflowY: 'visible',
          backgroundColor,
          maxWidth: size.width >= maxMobileSize ? '600px' : '90%',
          ...paperStyles,
          width: '100%'
        },
        '& .MuiDialogContent-root': {
          minWidth,
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollbarWidth: 'none',
          ...dialogContentStyle
        }
      }}
    >
      {!hideHeader && (
        <>
          <DialogTitle
            id="alert-dialog-title"
            className={classes.dialogTitle}
            sx={{
              ml: 4,
              mr: 4,
              mt: 4,
              p: 0
            }}
          >
            {title}
            <IconButton onClick={closeHandler}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <hr className={classes.divider} />
        </>
      )}
      <DialogContent
        sx={{
          ml: marginLeftRight,
          mr: marginLeftRight,
          px: 0,
          py: 1.5
          // maxWidth: size.width >= maxMobileSize ? 560 : 'auto'
        }}
      >
        {children}
      </DialogContent>
      {error && <p className={classes.error}>{t('common.errors.wentwrong')}</p>}
      {!hideFooter && (
        <DialogActions
          sx={{
            ml: 4,
            mr: 4,
            mb: 4,
            mt: 2,
            p: 0,
            pt: 1
          }}
        >
          {!onlyConfirm && (
            <MainButton
              size="xmedium"
              action={closeHandler}
              variant="secondary"
              outlined
              disabled={pending || disableConfirmBtn}
            >
              {cancelBtnTxt}
            </MainButton>
          )}
          {!onlyReject && (
            <Box sx={{ m: 1, position: 'relative' }}>
              <MainButton
                size="xmedium"
                action={confirmHandler}
                variant="secondary"
                disabled={pending || disableConfirmBtn}
                pending={pending}
              >
                {confirmBtnTxt}
              </MainButton>
            </Box>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

export default BaseModal;
